import { Link, View } from '@react-pdf/renderer'
import {
  SignatureAnchorKind,
  signatureAnchorUri,
} from 'features/reporting/pdfGeneration/signatureAnchors'
import { PDFStyles } from 'features/reporting/pdfGeneration/styles/PDFStyles'
import React from 'react'
import { SignoffRole } from 'types'

/** An empty cover-page cell that e-signing later fills with the signature or date. */
export const SignatureAnchor: React.FC<{
  kind: SignatureAnchorKind
  role: SignoffRole
}> = ({ kind, role }) => (
  <Link
    src={signatureAnchorUri(kind, role)}
    style={PDFStyles.contributorSignatureCell}>
    <View style={PDFStyles.fill} />
  </Link>
)
